import { useState } from 'react';
import { Check, Loader2 } from 'lucide-react';
import { cn } from '../../lib/cn';

export interface PageThumbnailProps {
  src: string;
  index: number;
  selected?: boolean;
  disabled?: boolean;
  onToggle?: (index: number) => void;
  rotation?: 0 | 90 | 180 | 270;
}

export function PageThumbnail({
  src,
  index,
  selected,
  disabled,
  onToggle,
  rotation = 0,
}: PageThumbnailProps) {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => onToggle?.(index)}
      aria-pressed={selected}
      className={cn(
        'group relative flex aspect-[3/4] items-center justify-center overflow-hidden rounded-[14px] border bg-white transition-all',
        selected
          ? 'border-brand-primary shadow-soft ring-2 ring-brand-primary/30'
          : 'border-stroke hover:border-brand-primary',
        disabled && 'cursor-not-allowed opacity-60',
      )}
    >
      {!loaded && !failed && (
        <Loader2 className="absolute h-5 w-5 animate-spin text-brand-primary" />
      )}
      {failed ? (
        <span className="text-xs text-text-muted">Превью недоступно</span>
      ) : (
        <img
          src={src}
          alt={`Страница ${index}`}
          loading="lazy"
          onLoad={() => setLoaded(true)}
          onError={() => setFailed(true)}
          style={{ transform: `rotate(${rotation}deg)` }}
          className={cn(
            'h-full w-full object-contain transition-transform duration-300',
            loaded ? 'opacity-100' : 'opacity-0',
          )}
        />
      )}
      <span className="absolute bottom-1 left-1 rounded-md bg-black/60 px-1.5 py-0.5 text-[10px] font-medium text-white">
        {index}
      </span>
      {onToggle && (
        <span
          className={cn(
            'absolute right-1 top-1 flex h-6 w-6 items-center justify-center rounded-full border-2 transition-all',
            selected
              ? 'border-brand-primary bg-brand-primary text-white'
              : 'border-white bg-white/80 text-transparent',
          )}
        >
          <Check size={14} />
        </span>
      )}
    </button>
  );
}
